import { render, staticRenderFns } from "./WaveVibrationViz.vue?vue&type=template&id=11a370a0&scoped=true"
import script from "./WaveVibrationViz.vue?vue&type=script&lang=js"
export * from "./WaveVibrationViz.vue?vue&type=script&lang=js"
import style0 from "./WaveVibrationViz.vue?vue&type=style&index=0&id=11a370a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a370a0",
  null
  
)

export default component.exports